import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid } from "@mui/material";
import { useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { makeGetRequest, makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";

function WaveLateFee() {
  const navigate = useNavigate();
  const { invId } = useParams();
  const [invoicetype, setInvoicetype] = React.useState("");
  const [invoicebillto, setInvoicebillto] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [invoicedate, setInvoicedate] = React.useState("");
  const [invoiceduedate, setInvoiceduedate] = React.useState("");
  const [invoiceamount, setInvoiceamount] = React.useState("");
  const [invoicetotalamount, setInvoiceTotalAmount] = React.useState("");
  const [maintenenceJsonList, setMaintenenceJsonList] = React.useState([]);
  const [invoicelatefee, setInvoicelatefee] = React.useState(0);
  const [, setInvoicevalue] = React.useState("");
  const [invoiceold, setInvoiceold] = React.useState("");
  const [showLoader, setShowLoader] = React.useState(true);

  var formikInitials = {
    invoicelatefee: invoicelatefee
  };

  const Validation_Schema = Yup.object().shape({
    invoicelatefee: Yup.string().required("Required").trim("White spaces not allow").strict(true),
  });

  async function GetInvoicePreview(invoiceId) {
    // let bodyFormData = {};
    
    await makeGetRequest("invoice/getinvoicepreviewweb/" + invoiceId)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data;
          console.log("json===>"+JSON.stringify(data))
          setInvoicetype(data.invoice_type)
          setInvoicebillto(data.user_obj.first_name + " " + data.user_obj.last_name);
          setSubject(data.subject)
          setInvoicedate(data.invoice_date)
          setInvoiceduedate(data.due_date)
          let calculated_Total = data.total_payment.toFixed(2);
          let newcalculatedTotal = parseFloat(calculated_Total) - parseFloat(data.advance_received)
          let totalPayableAmount = newcalculatedTotal.toFixed(2);
          setInvoiceamount(totalPayableAmount);
          setInvoiceTotalAmount(calculated_Total);
          
          console.log("dddddd"+JSON.stringify(data.maintenence_json_list))
          let filteredUsers = data.maintenence_json_list.filter((user) => {
            if(data.invoice_type=="Monthly Maintenance")
            {
              if(user.key=="Late Fee")
              {
                return user;
              }
            }
            else
            {
              if(user.name=="Late Fee")
              {
                return user;
              }
            }
            
          })

          let lateinvoicefees = parseFloat(filteredUsers[0].total);
          let latefeedecimal = lateinvoicefees.toFixed(2);
          let lateinvoicevalues= parseFloat(filteredUsers[0].value);
           setInvoiceold(latefeedecimal)
           setInvoicelatefee(latefeedecimal)
          // setInvoicelatefee(0)
           setInvoicevalue(lateinvoicevalues)
           console.log('lfee',latefeedecimal)

          let filteredmaintenence = data.maintenence_json_list.filter((user) => {
            if(data.invoice_type=="Monthly Maintenance")
            {
              if(user.key=="Late Fee")
              { 
              }
              else
              {
                return user;
              }
    
            }else
            {
              if(user.name=="Late Fee")
              { 
              }
              else
              {
                return user;
              }
            }
          })
         
          setMaintenenceJsonList(filteredmaintenence);
          setShowLoader(false)

        } else {
          swal("There was an error!", response.message, "warning");
          setShowLoader(false)
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
        setShowLoader(false)

      });
  }

  async function updateLateFee()
  {
    let inputdata;

    let miscellaneousJson; 
    if(invoicetype=="Monthly Maintenance")
    {
      miscellaneousJson = { key: "", value: "", total: "" };
      miscellaneousJson.key = "Late Fee";
      miscellaneousJson.value = 0;
      miscellaneousJson.total = 0;
    }
    else
    {
      miscellaneousJson = { name: "", value: "", total: "" };
      miscellaneousJson.name = "Late Fee";
      miscellaneousJson.value = 0;
      miscellaneousJson.total = 0;
    }
    
    maintenenceJsonList.push(miscellaneousJson);

    // alert("invoiceamount"+invoiceamount)
    // alert("invoiceold"+invoiceold)
    // alert("invoicelatefee"+invoicelatefee)
    // return false
    
    let fees = parseFloat(invoicetotalamount) - parseFloat(invoiceold);
    let newfees = parseFloat(fees)+parseFloat(0);
    let totalpayamount = newfees.toFixed(2);  
    inputdata = { total_payment: totalpayamount, maintenence_json_list: maintenenceJsonList,late_fee: 0 };
    inputdata.invoice_id = invId;
      await makePostRequest("invoice/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "Late fee has been Updated Successully....", "success", {
              timer: 1000,
              buttons: false,
            });
            GetInvoicePreview(invId);
          }
        })
        .catch((err) => {
          swal("There was an error!", "more error details", "warning");
        });
  }




  useEffect(() => {
    GetInvoicePreview(invId);
  }, []);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/InvoiceListing")}
              />
              Wave Late Fee
            </h1>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="createInvoiceNewMain">
              <div className="lateFeeMain">
                <div className="lateFeeInner">

                <Formik
                  enableReinitialize
                  initialValues={formikInitials}
                  validationSchema={Validation_Schema}
                  onSubmit={updateLateFee}
                >
                  {({
                    values,
                    handleChange,
                    errors,
                    setFieldTouched,
                    touched,
                    isValid,
                    handleSubmit,
                  }) => (
                    <Form>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12}>
                      {/* <div className="lateFeeTxLine"><b>Invoice Number</b><p>: RITS-012018-01</p></div> */}
                      <div className="lateFeeTxLine"><b>Invoice Type</b><p>: {invoicetype}</p></div>
                      <div className="lateFeeTxLine"><b>Invoice Bill To</b><p>: {invoicebillto}</p></div>
                      
                      <div className="lateFeeTxLine"><b>Invoice Subject</b><p>: {subject}</p></div>
                      <div className="lateFeeTxLine"><b>Invoice Date</b><p>: {moment(invoicedate).format("DD/MM/YYYY")}</p></div>
                      <div className="lateFeeTxLine"><b>Invoice Due Date</b><p>: {moment(invoiceduedate).format("DD/MM/YYYY")}</p></div>
                      <div className="lateFeeTxLine"><b>Total Due Amount</b><p>: <CurrencyRupeeIcon /> {invoiceamount}</p></div>

                      {/* added by me change*/}
                      
                      <div className="lateFeeTxLine"><b>Late Fees </b><p>: <CurrencyRupeeIcon /> {invoicelatefee}
                      
                      {/* <input type="hidden"  value={invoicelatefee}
                            onChange={handleChange("invoicelatefee")}
                            onBlur={() => setFieldTouched("invoicelatefee")}
                            onChangeCapture={(e) => setInvoicelatefee(e.target.value)}placeholder="Enter Late Fee"/> */}

                            </p></div>
                    </Grid>
                    <Grid item xs={12} md={12} style={{textAlign:'center'}}>
                      <Button className="primaryBtn" type="submit" style={{float:'none'}}>Remove Late Fee</Button>
                    </Grid>
                  </Grid>

                  </Form>
                  )}
                </Formik>

                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default WaveLateFee;
